import gql from 'graphql-tag';

import metadataQuery from './metadataQuery';
import searchQuery from './searchQuery';
import linkingQuery from './linkingQuery';
import poiQuery from './poiQuery';
import pricesQuery from './pricesQuery';
import { getCitiesQuery } from './citiesQuery';

const getSearchQuery = featureFlags => gql`
  query Search(
    $cityId: String!
    $filters: FiltersInput
    $locale: String
    $url: String
    $moveIn: String
    $moveOut: String,
    $limit: Int
  ) {
    isLogged
    ${metadataQuery}
    ${searchQuery}
    ${linkingQuery}
    ${poiQuery}
    ${pricesQuery}
    ${getCitiesQuery(featureFlags.enableCityDiscounts)}
    areas(city: $cityId) {
      id
      name
    }
  }
`;

export const requestSearchData = (client, featureFlags = {}) => (
  cityId,
  filters,
  locale = 'en',
  moveIn,
  moveOut,
  url,
  limit
) =>
  client.query({
    errorPolicy: 'all',
    query: getSearchQuery(featureFlags),
    variables: {
      cityId,
      filters,
      locale,
      url,
      moveIn,
      moveOut,
      limit
    }
  });

export default getSearchQuery;
